import React from 'react'
import { IconButton } from '../UI/IconButton/IconButton'
import { useShowActionsMenu } from '../UI/ActionsMenu/hooks/useShowActionsMenu';

export const MoreTabsButton = ({ menuItems, disabled }) => {
  const [showMenuActions] = useShowActionsMenu();

  const menuOptions = {
    items: menuItems,
    minMenuHeight: 35 * menuItems.length,
    offsetY: 7,
  };

  const optionsClassName =
    !disabled
      ? "btn-primary IconButton primary trigger-actions-menu"
      : "IconButton gray trigger-actions-menu";

  const optionsIconName = !disabled ? "options" : "options-gray";

  return (
    <div className="buttons-block">
      <IconButton
        iconName={optionsIconName}
        className={optionsClassName}
        onClick={showMenuActions(menuOptions)}
        disabled={disabled}
      />
    </div>
  )
}
